/**
 * There is no deleted state: deleting a topic would take the meaning of every
 * historical assignment with it, so retirement is a status.
 */
export enum TaxonomyStatus {
  Active = 'active',
  Deprecated = 'deprecated',
}
